// extracted by mini-css-extract-plugin
module.exports = {"portal":"Dialog_portal__Pcz1f"};